import { useTranslation } from "react-i18next";
import { Building2, Users, CalendarRange, ChevronDown } from "lucide-react";

const FILTERS = ["all", "pending", "approved", "rejected"];

// حقل اختيار بارز بأسلوب 3D Neu: أيقونة في البداية + سهم في النهاية ليبدو واضحاً أنه قابل للضغط.
const SelectBox = ({ icon: Icon, value, onChange, testid, children }) => (
  <div className="relative flex items-center rounded-2xl bg-background shadow-neu-sm transition-shadow duration-300 hover:shadow-neu focus-within:ring-2 focus-within:ring-ring">
    <Icon className="pointer-events-none absolute start-3 h-4 w-4 text-primary" />
    <select data-testid={testid} value={value} onChange={onChange}
      className="neu-select h-12 w-full appearance-none rounded-2xl bg-transparent ps-9 pe-9 text-sm font-bold text-foreground focus:outline-none">
      {children}
    </select>
    <ChevronDown className="pointer-events-none absolute end-3 h-4 w-4 text-muted-foreground" />
  </div>
);

export const HistoryFilters = ({ status, setStatus, branch, setBranch, employee, setEmployee, month, setMonth, branches, users, months }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-3" data-testid="history-filters">
      <div className="flex flex-wrap gap-2">
        {FILTERS.map((f) => (
          <button key={f} type="button" data-testid={`history-filter-${f}`} onClick={() => setStatus(f)}
            className={`rounded-2xl bg-background px-4 py-2 text-sm font-black transition-[box-shadow,transform] duration-300 ${status === f ? "shadow-neu-in text-primary" : "shadow-neu-sm text-muted-foreground hover:-translate-y-0.5"}`}>
            {f === "all" ? t("requests.filterAll") : t(`myRequests.status.${f}`)}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-3">
        <SelectBox icon={Building2} testid="history-branch" value={branch} onChange={(e) => setBranch(e.target.value)}>
          <option value="">{t("penalty.filters.branch")}</option>
          {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </SelectBox>
        <SelectBox icon={Users} testid="history-employee" value={employee} onChange={(e) => setEmployee(e.target.value)}>
          <option value="">{t("requests.allEmployees")}</option>
          {users.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
        </SelectBox>
        <SelectBox icon={CalendarRange} testid="history-month" value={month} onChange={(e) => setMonth(e.target.value)}>
          <option value="">{t("requests.allMonths")}</option>
          {months.map((m) => <option key={m} value={m}>{m}</option>)}
        </SelectBox>
      </div>
    </div>
  );
};
